import { Box, Chip, Stack, Typography, useTheme } from "@mui/material";
import { Map2dViewer } from "../../SeatMap/Map2dViewer";
import {
  selectSectionSelected,
  selectSections,
} from "@/global/store/data/gameFilters";
import { useAppStore } from "@/global/store";
import React from "react";
import { useTeamConfig } from "@/global/hooks/useTeamConfig";
import { useSeatMap2d } from "../../InteractiveSeatMap/useSeatMap2d";
import {
  toggleViewerNodeSelection,
  calcDynamicSeatMapId,
  type SeatMap,
} from "../../InteractiveSeatMap/utils.seatMap";
import { useSelectActiveEvent } from "../../PurchaseSeats/ChooseSeats/useSelectActiveEvent";

export function SectionSelector(props: { title?: string }) {
  const theme = useTheme();
  const teamConfig = useTeamConfig();
  const { languages } = teamConfig;
  const [mapId, setSeatMapId] = React.useState<SeatMap | null>(null);
  const availableSections = useAppStore(selectSections);
  const selectedSection = useAppStore(selectSectionSelected);
  const [selectedNode, setSelectedNode] = React.useState<any>(null);
  const { activeEvent } = useSelectActiveEvent();
  const {
    viewer,
    setViewerInstance,
    setViewerAvailability,
    setSelectedSection,
    resetSelectedSection,
  } = useSeatMap2d();

  const onClick = (obj: any) => {
    const viewer = obj.instance;
    const [node] = obj.nodes;
    if (!viewer || !node) return;
    toggleViewerNodeSelection(viewer, node);
    setSelectedNode(node);
  };

  React.useEffect(() => {
    setViewerAvailability();
  }, [viewer, availableSections]);

  React.useEffect(() => {
    if (selectedNode) setSelectedSection(selectedNode);
  }, [selectedNode]);

  React.useEffect(() => {
    if (activeEvent) {
      const seatMap = calcDynamicSeatMapId(teamConfig, activeEvent);
      setSeatMapId(seatMap);
    }
  }, [activeEvent]);

  return (
    <Box>
      {props?.title ? (
        <Box>
          <Typography
            variant="subtitle1"
            fontWeight={"700"}
            color="text.primary"
          >
            {props?.title}
          </Typography>
        </Box>
      ) : null}

      <Box
        mt={2}
        border={`1px solid ${theme.palette.divider}`}
        borderRadius={0.8}
      >
        <Box p={2} borderBottom={`1px solid ${theme.palette.divider}`}>
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Box>
              <Typography variant="subtitle1" fontWeight={"600"}>
                {languages?.purchaseSeats?.sectionSelectorDescription ||
                  "Show Game with seats in:"}
              </Typography>
            </Box>
            <Box>
              {selectedSection ? (
                <Box>
                  <Chip
                    clickable
                    size="medium"
                    label="Reset"
                    onClick={() => resetSelectedSection()}
                  />
                </Box>
              ) : null}
            </Box>
          </Stack>
        </Box>

        {mapId ? (
          <Stack alignItems={"center"} key={`${mapId.venueId}${mapId.mapId}`}>
            <Box width={"100%"}>
              <Map2dViewer
                venueId={mapId.venueId}
                mapId={mapId.mapId}
                onClick={onClick}
                onLoad={(viewer) => setViewerInstance(viewer)}
              />
            </Box>
          </Stack>
        ) : null}
      </Box>
    </Box>
  );
}
